/**
 * DOM Deferred Handlers - Non-Critical JavaScript
 * PERFORMANCE OPTIMIZATION: Deferred initialization code that doesn't need to run during page load
 * This file loads AFTER first contentful paint to reduce Total Blocking Time (TBT)
 *
 * Expected TBT Reduction: ~800ms
 */

(function() {
  'use strict';

  // Add DOM loaded classes (deferred to avoid blocking)
  document.body.classList.add('dom-loaded');

  // Add delayed class after 6 seconds
  setTimeout(() => {
    document.body.classList.add('dom-loaded-plus-6');
  }, 6000);

  // External links in new tab (if enabled via theme settings)
  if (theme.settings.externalLinksNewTab) {
    document.addEventListener('click', (evt) => {
      const link = evt.target.tagName === 'A' ? evt.target : evt.target.closest('a');
      if (link && link.tagName === 'A' && window.location.hostname !== new URL(link.href).hostname) {
        link.target = '_blank';
      }
    });
  }

  // Smooth scroll for anchor links (progressive enhancement)
  document.addEventListener('click', (evt) => {
    if (evt.target.tagName === 'A' && window.location.hostname === new URL(evt.target.href).hostname
      && evt.target.href.includes('#')) {
      document.getElementsByTagName('html')[0].style.scrollBehavior = 'smooth';
      setTimeout(() => {
        document.getElementsByTagName('html')[0].style.scrollBehavior = '';
      }, 1000);
    }
  });

})();
